module.exports = __webpack_public_path__ + "img/Pic_Services-1.a6c93c0b.jpg";